import React, { Component, useState } from 'react';
import { inject, observer } from 'mobx-react';
import ProviderStore from '../../stores/ProvidersStore';
import TestSubscription from './TestSubscription';
import { Link, Redirect } from 'react-router-dom';
import { PROVIDERS_PAGE_PATH } from '../../Settings';
import ProviderDetails from './ProviderDetails';
import SwitcherComponent from '../common/inputs/SwitcherComponent';
import PopupComponent, { ErrorPopupComponent, ErrorPopupWithGridComponent, GenericSuccessPopupComponent, ErrorPopupWithTextAreaComponent, PhaseCondition, SuccessPopupComponent, ValidationSuccessPopupComponent, WarningPopupComponent, FullSyncWarningPopupComponent } from '../common/popups/PopupComponent';
import ProviderDetailsErrorModel from '../../models/ProviderDetails/ProviderDetailsErrorModel';
import ProviderDetailsExpansion, { SubjectMapping ,CourseMapping} from '../../models/ProviderDetails/ProviderDetailsExpansion';
import ProviderModel, { CSOD_PREDEFINED_SUBJECTS_MAPPING,CSOD_PREDEFINED_COURSE_MAPPING, ProviderModifications } from '../../models/ProviderDetails/ProviderModel';
import ProviderDataGridComponent from '../ProviderData/ProviderDataGridComponent';
import PackagesGridComponent from '../packages/PackagesGridComponent';
import CourseEligibilityGridComponent from '../packages/CourseEligibilityGridComponent';
import SSOConfigErrorModel from '../../models/SSOConfig/SSOConfigErrorModel';
import ClientRegistration from './ClientRegistration';
import ClientRegistrationErrorModel from '../../models/ClientRegistration/ClientRegistrationErrorModel';
import CodeHelpers from '../../helpers/common/CodeHelpers';
import LabelComponent from '../common/inputs/LabelComponent';
import LargeTextboxComponent from '../common/inputs/LargeTextboxComponent';
import { InputWidthTypes } from '../../helpers/common/StyleHelper';
import FrameworkValidationService from '../../helpers/framework/FrameworkValidationService';
import GraphQLHelper from '../../helpers/common/GraphQLHelper';
import UpsertProviderModel from '../../models/ProviderDetails/UpsertProviderModel';
import LoaderComponent from '../common/LoaderComponent';
import "./FrameworkComponent.css";
import { FrameworkModes } from '../../models/ProviderFramework/FrameworkMode';
import GlobalLoaderStore from '../../stores/GlobalLoaderStore';
import ProviderToolData from '../../models/TestSubscription/ProviderToolData';
import HttpHelper from '../../helpers/common/HttpHelper';
import { ProviderOfferingType } from '../../models/ProviderDetails/ProviderOfferingType';
import DirectSubscriptionInput from '../../models/TestSubscription/DirectSubscriptionInput';
import { TestSubscriptionOption } from '../../models/TestSubscription/TestSubscriptionOption';
import SubscriptionInput from '../../models/TestSubscription/SubscriptionInput';
import ValidationApiErrorModel from '../../models/ProviderDetails/ValidationApiErrorModel';
import BundleProviderParameter from '../../models/TestSubscription/BundleProviderParameter';
import { v4 } from 'uuid';

import FrameworkConstants from '../../constants/frameworkConstants';
import { TrainingType } from '../../models/ProviderDetails/TrainingType';
import { Auth } from '@aws-amplify/auth';

const { REACT_APP_ENV } = process.env;
console.log(process.env);
enum TabNames {
    ProviderDetails = "Provider History",
    PackageDetails = "Package Details",
    CourseEligibility = "Course Eligibility"
}

interface FrameworkComponentProps {
    globalLoader?: GlobalLoaderStore
}

interface FrameworkComponentState {
    CurrentTab: TabNames,
    ReadonlyState: boolean,
    AdminsState: boolean,
}

@inject('packages','providerData', 'globalLoader', 'routing')
@observer
export default class FrameworkMonitoringComponent extends Component<FrameworkComponentProps, FrameworkComponentState> {
    private phaseConditions: PhaseCondition[] = [];

    constructor(props: FrameworkComponentProps) {
        super(props);
        this.state = {
            CurrentTab: TabNames.ProviderDetails,
            ReadonlyState: false,
            AdminsState: false,
        }
        
        Auth.currentAuthenticatedUser().then(res=>{
            var groups = res.signInUserSession.accessToken.payload["cognito:groups"];
            if(groups && groups.includes('Readonly') && !groups.includes('Admins'))
              this.setState({ReadonlyState: true});
            if(groups.includes('Admins')){
              this.setState({AdminsState: true});
            }
        });
    }

    getGoToTabFunction = (tab: TabNames) => {
        return (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            event.preventDefault();
            if (this.state.CurrentTab !== tab) {
                this.setState({ CurrentTab: tab });
            }
        }
    }

    renderTab(tab: TabNames, cy_data?: string) {
        return <div className={`csod-tab-item non-selectable ${this.state.CurrentTab === tab ? "active-item gray-text" : "blue-text"}`} onClick={this.getGoToTabFunction(tab)} cy-data={cy_data}>{tab}</div>
    }

    render() {
        return <div className="csod-framework-container">
                <div className="csod-tabs-container" style={{paddingTop:'1vw'}}>
                    {this.renderTab(TabNames.ProviderDetails)}
                    {this.renderTab(TabNames.PackageDetails)}
                    {this.renderTab(TabNames.CourseEligibility)}
                </div>
                <div className="csod-framework-content">
                    {this.state.CurrentTab === TabNames.ProviderDetails ? <ProviderDataGridComponent /> : null}
                    {this.state.CurrentTab === TabNames.PackageDetails ? <PackagesGridComponent /> : null}
                    {this.state.CurrentTab === TabNames.CourseEligibility ? <CourseEligibilityGridComponent /> : null}
                </div>
            </div>
    }
}